/*
 *@description:
 *@modifyContent: 评论标签处理
 *@author: qiuhongyang
 *@date: 2021-05-18 13:32:19
 *
*/


 
export default function transFace(html: string) {
  try {
    // var facearr = ["微笑", "大笑", "鼓掌", "为什么", "哭", "怒", "滴汗", "俏皮", "傲", "好困惑", "兴奋", "加油", "困顿", "想一下", "撇嘴", "色", "发呆", "得意", "害羞羞", "大哭", "呲牙", "惊讶", "囧", "抓狂", "偷笑", "愉快", "憨笑", "晕", "再见", "坏笑", "左哼哼", "右哼哼", "哈欠", "委屈", "快哭了", "亲", "可怜", "口罩", "笑哭", "惊吓", "哼", "捂脸", "奸笑", "吃瓜", "旺柴", "围观", "摊手", "爱心", "献花", "福", "拜神", "胜利", "赞", "握手", "抱拳", "勾引", "拳头", "OKOK", "强壮", "毛估估", "亏大了", "赚大了", "牛", " ", "成交", "财力", "护城河", "复盘", "买入", "卖出", "满仓", "空仓", "抄底", "看多", "看空", "加仓", "减仓", "上涨", "下跌", "财神", "火箭", "龙头", "韭菜", "面", "泡沫", "惨!关灯吃面"];

    var facearr = ["微笑", "大笑", "鼓掌", "为什么", "哭", "怒", "滴汗", "俏皮", "傲", "好困惑",
      "兴奋", "加油", "困顿", "想一下", "撇嘴", "色", "发呆", "得意", "害羞羞", "大哭",
      "呲牙", "惊讶", "囧", "抓狂", "偷笑", "愉快", "憨笑", "晕", "再见", "坏笑",
      "左哼哼", "右哼哼", "哈欠", "委屈", "快哭了", "亲", "可怜", "口罩", "笑哭", "惊吓",
      "哼", "捂脸", "奸笑", "吃瓜", "旺柴", "围观", "摊手", "爱心", "献花", "福",
      "拜神", "胜利", "赞", "握手", "抱拳", "勾引", "拳头", "OKOK", "强壮", "毛估估",
      "亏大了", "赚大了", "牛", " ", "成交", "财力", "护城河", "复盘", "买入", "卖出",
      "满仓", "空仓", "抄底", "看多", "看空", "加仓", "减仓", "上涨", "下跌", "财神",
      "火箭", "龙头", "韭菜", "面", "泡沫", "惨!关灯吃面",
      "666", "叹气", "让我看看", "发财", "主力", "梭哈", "国家队", "中签", "干杯"];

    var re = new RegExp('\\[[^ \f\n\r\t\v<>]+?\\]', "ig");

    html = html.replace(re, function (item) {
      for (var i = 0; i < facearr.length; i++) {
        if ("[" + facearr[i] + "]" == item) {

          return '<img title="' + facearr[i] + '" src="//gbfek.dfcfw.com/face/emot_default_28x28/emot' + (i + 1) + '.png" alt="' + item + '" class="article_icon">';

        }
      }
      return item;
    });

   

  } catch (error) {
    
  }

  return html;
}